//ATMOSPHERE list
export const ATMOSPHERE_LIST_REQUEST = 'ATMOSPHERE_LIST_REQUEST';
export const ATMOSPHERE_LIST_SUCCESS = 'ATMOSPHERE_LIST_SUCCESS';
export const ATMOSPHERE_LIST_FAIL = 'ATMOSPHERE_LIST_FAIL';
